// @ts-nocheck
import { Disclaimer } from '../pages/Disclaimer/Disclaimer';
import { Splash } from '../pages/Splash/Splash';
// import { CameraAccess } from '../pages/CameraAccess';
// import { ToyScan } from '../pages/ToyScan';
// import { ScanConfirmation } from '../pages/ScanConfirmation';
import { Onboarding } from '../pages/Onboarding/Onboarding';
// import { CharacterSelection } from '../pages/CharacterSelection';
import { LevelSelection } from '../pages/LevelSelection/LevelSelection';
// import {GameInstructions} from '../pages/GameInstructions/GameInstructions';
import { GamePlay } from '../pages/GamePlay/GamePlay';
import { Replay } from '../pages/PlayAgain/Replay';

let idx = 0;
export const pagesMap = {
  DISCLAIMER: idx,
  SPLASH: ++idx,
  ONBOARDING: ++idx,
  LEVEL_SELECTION: ++idx,
  GAME_PLAY: ++idx,
  // CAMERA_ACCESS: ++idx,
  // CARD_SCAN: ++idx,
  // SCAN_CONFIRMATION: ++idx,
  // CHARACTER_SELECTION: ++idx,
  // GAME_INSTRUCTIONS: ++idx,
  REPLAY: ++idx,
};

export default pagesMap;

export const pageComponents = {
  DISCLAIMER: Disclaimer,
  SPLASH: Splash,
  ONBOARDING: Onboarding,
  LEVEL_SELECTION: LevelSelection,
  GAME_PLAY: GamePlay,
  // CAMERA_ACCESS: CameraAccess,
  // CARD_SCAN: ToyScan,
  // SCAN_CONFIRMATION: ScanConfirmation,
  // CHARACTER_SELECTION: CharacterSelection,
  // GAME_INSTRUCTIONS: GameInstructions,
  REPLAY: Replay,
};
